module.exports = __webpack_public_path__ + "img/Menu-ManifiestoX.b7d11343.jpg";